import React from 'react'

export function CityBlack() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="none"
      viewBox="0 0 18 18"
    >
      <path
        fill="#FFFFFF"
        fillRule="evenodd"
        d="M.938 15.75c0-.31.251-.563.562-.563h15a.562.562 0 110 1.126h-15a.562.562 0 01-.563-.563z"
        clipRule="evenodd"
      />
      <path
        fill="#FFFFFF"
        fillRule="evenodd"
        d="M3.75 10.313a.187.187 0 00-.188.187V15c0 .104.084.188.188.188h1.5A.187.187 0 005.438 15v-4.5a.187.187 0 00-.188-.188h-1.5zm-1.313.187c0-.725.588-1.313 1.313-1.313h1.5c.725 0 1.313.588 1.313 1.313V15c0 .725-.588 1.313-1.313 1.313h-1.5A1.312 1.312 0 012.437 15v-4.5z"
        clipRule="evenodd"
      />
      <path
        fill="#FFFFFF"
        fillRule="evenodd"
        d="M3.938 12.75c0-.31.251-.563.562-.563h.375a.562.562 0 110 1.126H4.5a.562.562 0 01-.563-.563z"
        clipRule="evenodd"
      />
      <path
        fill="#FFFFFF"
        fillRule="evenodd"
        d="M6.75 2.063a.188.188 0 00-.188.187V15c0 .104.084.188.188.188h7.5a.187.187 0 00.188-.188V2.25a.187.187 0 00-.188-.188h-7.5zm-1.313.187c0-.725.588-1.313 1.313-1.313h7.5c.725 0 1.313.588 1.313 1.313V15c0 .725-.588 1.313-1.313 1.313h-7.5A1.312 1.312 0 015.437 15V2.25z"
        clipRule="evenodd"
      />
      <path
        fill="#FFFFFF"
        d="M9.75 3.75h-1.5v1.5h1.5v-1.5zM12.75 3.75h-1.5v1.5h1.5v-1.5zM9.75 6.375h-1.5v1.5h1.5v-1.5zM12.75 6.375h-1.5v1.5h1.5v-1.5zM12.75 9h-1.5v1.5h1.5V9zM12.75 11.625h-1.5v1.5h1.5v-1.5z"
      />
    </svg>
  )
}
